module.exports = __webpack_public_path__ + "img/flash.ecabc247.svg";